// Payload-free browser diagnostics. No HTTP requests, storage writes or SDK reads.
export function beginBrowserLeadRead(query, operation, log = console.info) {
  try {
    const parts = new URL(String(query)).pathname.replace(/\.json$/, '').split('/').filter(Boolean);
    const root = decodeURIComponent(parts[0] || '');
    if (parts.length && !['leads', 'demo_leads'].includes(root)) return null;
    const readId = (typeof window !== 'undefined' && window.crypto?.randomUUID?.())
      || `browser-${Date.now()}-${Math.random()}`;
    const callChain = String(new Error().stack || '').split('\n').slice(1).map(line => {
      const match = line.match(/(?:at (?:async )?([\w.$<>]+) \()?.*\/([\w.-]+\.(?:mjs|js|cjs)):(\d+):\d+\)?$/);
      return match ? `${match[2]}:${match[1] || 'anonymous'}:${match[3]}` : null;
    }).filter(Boolean).slice(0, 8);
    let finished = false;
    const event = (phase, outcome) => {
      try { log(`[firebase-leads-read] ${JSON.stringify({
        version:1,packageTag:'aurora-history-demand-leads-full-v2',source:'browser-sdk',operation,readId,phase,outcome,callChain,
        root:root || 'database-root',target:parts.length > 1 ? `${root}/:record` : root || ':database-root',
        measurement:'SDK invocation/delivery; not measured network bytes',
      })}`); } catch {}
    };
    event('started');
    return { event, finish(outcome) {
      if (!finished) { finished = true; event('finished', outcome); }
    } };
  } catch { return null; }
}
export function observeLeadGet(implementation, args, log) {
  const trace = beginBrowserLeadRead(args[0], 'get', log);
  try {
    const result = implementation(...args);
    if (trace) result.then(() => trace.finish('resolved'), () => trace.finish('rejected'));
    return result;
  } catch(error) { trace?.finish('error'); throw error; }
}
export function observeLeadSubscription(implementation, args, log) {
  const trace = beginBrowserLeadRead(args[0], 'onValue', log);
  if (!trace) return implementation(...args);
  const forwarded = [...args], callback = forwarded[1];
  if (typeof callback === 'function') forwarded[1] = function(...values) {
    trace.event('snapshot');
    return callback.apply(this, values);
  };
  try {
    const stop = implementation(...forwarded);
    return function(...values) {
      try { return stop.apply(this, values); }
      finally { trace.finish('unsubscribed'); }
    };
  } catch(error) { trace.finish('error'); throw error; }
}
export function observeLeadTransaction(implementation, args, log) {
  const trace = beginBrowserLeadRead(args[0], 'runTransaction', log);
  if (!trace) return implementation(...args);
  const forwarded = [...args], update = forwarded[1];
  forwarded[1] = function(...values) {
    trace.event('transaction-read');
    return update.apply(this, values);
  };
  try {
    const result = implementation(...forwarded);
    result.then(() => trace.finish('resolved'), () => trace.finish('rejected'));
    return result;
  } catch(error) { trace.finish('error'); throw error; }
}
